import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class SweetAlertService {

    constructor() { }

    success(title?: string, text?: string) {

        const options: any = {
            icon: 'success',
            title: title || '',
            confirmButtonText: 'Aceptar',
            didOpen: () => Swal.hideLoading()
        };

        if (text) options.text = text;

        return Swal.fire(options);

    }

    warning(title?: string, text?: string) {

        const options: any = {
            icon: 'warning',
            title: title || 'Advertencia',
            confirmButtonText: 'Aceptar',
            customClass: {
                confirmButton: 'swal-custom-confirm-button'
            },
            didOpen: () => Swal.hideLoading()
        };

        if (text) options.text = text;

        return Swal.fire(options);
    }

    info(title?: string, text?: string) {

        const options: any = {
            icon: 'info',
            title: title || '',
            confirmButtonText: 'Aceptar',
            customClass: {
                confirmButton: 'swal-custom-confirm-button'
            },
            didOpen: () => Swal.hideLoading()
        };

        if (text) options.text = text;

        return Swal.fire(options);
    }

    error(title?: string, text?: string) {

        let options: any = {
            icon: 'error',
            title: title || 'Ocurrió algo inesperado',
            text: text || 'Intenta de nuevo más tarde',
            confirmButtonText: 'Aceptar',
            customClass: {
                confirmButton: 'swal-custom-confirm-button'
            },
            didOpen: () => Swal.hideLoading()
        };

        return Swal.fire(options);
    }

    loading(title?: string, text?: string) {
        Swal.fire({
            title: title || 'Cargando...',
            text: text || 'Espera un momento por favor',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

    }

    confirm(title?: string, text?: string) {
        return new Promise((resolve, reject) => {
            let options: any = {
                icon: 'warning',
                title: title || 'Confirmación',
                text: text || '¿Estás seguro de realizar esta acción?',
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                allowEscapeKey: true,
                reverseButtons: true,
                customClass: {
                    confirmButton: 'swal-custom-confirm-button'
                },
            };

            Swal.fire(options).then(result => {
                if (result.value)
                    resolve(true);
                else
                    resolve(false);
            });
        });

    }

    close() {
        Swal.close();
    }

    exec(options: any) {
        return Swal.fire(options);
    }

    /* TOAST */

    toastSuccess(title?: string, timer?: number) {
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: timer || 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });

        Toast.fire({
            icon: "success",
            title: title || ""
        });
    }

    toastWarning(title?: string, timer?: number) {
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: timer || 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });

        Toast.fire({
            icon: "warning",
            title: title || ""
        });
    }


}
